import FormTextAreaComponent from "@via/components/inputs/form-textarea-component";
import Modal from "@via/components/modal.tsx";
import { requiredValidation } from "@via/utils/form-validators";
import { usePremiumRunSupport } from "@via/pages/projects/runs/runs.api.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { useForm } from "react-hook-form";
import { type PremiumRunSupportRequestBody } from "common";

interface PremiumRunModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const PremiumRunModal = ({ open, setOpen }: PremiumRunModalProps) => {
  const {
    mutateAsync: sendPremiumRunSupport,
    isPending: isSendPremiumRunSupportLoading,
  } = usePremiumRunSupport();

  const { control, handleSubmit } = useForm<PremiumRunSupportRequestBody>({
    mode: "onChange",
  });

  const handleCancel = () => {
    setOpen(false);
  };

  // Resolves true once the message is sent, false on an invalid form (the dialog stays open);
  // a failed send rejects, which also keeps it open.
  const handleConfirmModal = async (): Promise<boolean> => {
    let sent = false;
    await handleSubmit(async data => {
      await sendPremiumRunSupport(data);
      sent = true;
    })();
    return sent;
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Premium Run Setup"
      confirmText="Send"
      size={ModalSize.Large}
      onCancel={handleCancel}
      isConfirmLoading={isSendPremiumRunSupportLoading}
      onConfirm={handleConfirmModal}>
      <form onSubmit={e => e.preventDefault()}>
        <div className="mt-0 max-w-3xl">
          <div className="mb-4 text-sm text-gray-600">
            <p className="mb-3">
              For new customers, we offer a variety of solutions for submitting
              runs. Before proceeding, we&apos;d like to gather some additional
              information to ensure we tailor the setup to your specific needs.
            </p>
            <p className="mb-3">
              <span className="font-bold">Data Processing Preferences:</span> Do
              you have any preferred way of processing your data? (e.g. AWS
              Cloud, Google Cloud, or High-Performance Computing) Would you like
              to process on your compute environments or would you like to use
              Foundry&apos;s compute environment?
            </p>
            <p className="mb-3">
              <span className="font-bold">Your Goals:</span> Do you have any
              specific goals or objectives do you aim to achieve by using
              Foundry?
            </p>
            <p className="mb-3">Looking forward to your response!</p>
            <p className="mb-3">
              <span className="font-bold">Contact our support:</span>
            </p>
            <FormTextAreaComponent
              name="message"
              placeholder="Write your message here"
              showRequiredField={true}
              control={control}
              validations={requiredValidation("Message")}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default PremiumRunModal;
